export const ACTION_GET_PRODUCTS_NAME = '/ProductReviews/GetProductsName';